<div class="d-flex box stampPage">
  <div class="col-12">
    <span class="title">{{ label }}</span>
    <div class="d-flex flex-row box-scrollable py-3">
      <div (click)="handleStampClick(stamp)" class="me-3 stamp-box-text" *ngFor="let stamp of stamps">
        <div class="position-relative">
          <i *ngIf="stamp.eventReviewStatus"
            aria-hidden="true"
            class="review-icon cursor-pointer fa fa-quote-right {{ stamp.image.indexOf('gold') >= 0 ? 'text-white' : ''}}"
            data-toggle="tooltip"
            title="Read Review"></i>
          <img class="stamp-image" src="{{ stamp.image }}" alt="logo" />
          <div>{{stamp.name}}</div>
        </div>
      </div>
      <div class="me-3" *ngFor="let number of [0,1,2]">
        <img src="{{ comingSoonImage }}" alt="logo" />
      </div>
    </div>
  </div>
</div>
<div *ngIf="showStampDetails">
  <app-popup (closeEvent)="togglePopupState()"
    #popup
    (popupInputSubmit)="handlePopupInputFormData($event)"
    [popupType]="popupType"
    [eventType]="eventType"
    [readonly]="!!communityPassport"
    [popupData]="selectedStamp"></app-popup>
</div>
